import _objectWithoutProperties from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElementHook, createLayerHook, updateMediaOverlay } from '@react-leaflet/core';
import { SVGOverlay as LeafletSVGOverlay } from 'leaflet';
import { forwardRef, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';
export var useSVGOverlayElement = createElementHook(function createSVGOverlay(props, context) {
  var attributes = props.attributes,
      bounds = props.bounds,
      options = _objectWithoutProperties(props, ["attributes", "bounds"]);

  var container = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  container.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

  if (attributes != null) {
    Object.keys(attributes).forEach(function (name) {
      container.setAttribute(name, attributes[name]);
    });
  }

  return {
    instance: new LeafletSVGOverlay(container, bounds, options),
    container: container,
    context: context
  };
}, updateMediaOverlay);
export var useSVGOverlay = createLayerHook(useSVGOverlayElement);

function SVGOverlayComponent(_ref, ref) {
  var children = _ref.children,
      options = _objectWithoutProperties(_ref, ["children"]);

  var _useSVGOverlay$curren = useSVGOverlay(options).current,
      instance = _useSVGOverlay$curren.instance,
      container = _useSVGOverlay$curren.container;
  useImperativeHandle(ref, function () {
    return instance;
  });
  return container == null || children == null ? null : /*#__PURE__*/createPortal(children, container);
}

export var SVGOverlay = /*#__PURE__*/forwardRef(SVGOverlayComponent);